import { gql } from '@apollo/client';

export const GENERATE_QR_CODE = gql`
  mutation generateQRCode {
    QrCode_generate {
      success
      message
      qrCodeData
      loginToken
      expiresIn
    }
  }
`;
